import type { ToastMessageOptions } from 'primevue/toast'
import { useToast } from 'primevue/usetoast'

interface ToastMessage {
  heading?: string
  message?: string
  life?: number
  closeable?: boolean
  data?: Record<string, unknown>
  type?:
    | 'default'
    | 'error'
    | 'app-update'
    | 'file-submission-upload'
    | 'file-submission-processing'
    | 'spinner'
    | 'interaction-end'
    | 'offline'
}

export function useToastNotifications() {
  const toast = useToast()

  function transformToastMessageToPVToast(
    message: ToastMessage,
  ): ToastMessageOptions {
    return {
      severity: 'info',
      summary: message.heading,
      detail: message.message,
      life: message.life,
      closable: message.closeable,
      group: message.type || 'default',
      data: message.data,
    }
  }

  function addToast(message: ToastMessage) {
    toast.add(transformToastMessageToPVToast(message))
  }

  function removeToast(message: ToastMessage) {
    toast.remove(transformToastMessageToPVToast(message))
  }

  function removeToastsByType(type: string) {
    toast.removeGroup(type)
  }

  function removeAllToasts() {
    toast.removeAllGroups()
  }

  return {
    addToast,
    removeToast,
    removeToastsByType,
    removeAllToasts,
  }
}
